import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { helper } from 'src/environments/helper';
import { PrioritiesService } from '../priorities.service';
import { AddPriorities } from '../priorities.interface';
import { notDefaultValidator } from 'src/app/shared/validators/not-default';

@Component({
    selector: 'app-add-cerere-priority',
    templateUrl: './add-cerere-priority.component.html',
    styleUrls: ['./add-cerere-priority.component.scss'],
})
export class AddCererePriorityComponent implements OnInit {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    filterParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    zileOptions: { name: string; id: number }[] = [
        { name: '--Alegeți--', id: -1, },
        { name: 'Zile calendaristice', id: 1 },
        { name: 'Zile lucrătoare', id: 2, }
    ];

    form: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required]),
        slug: new FormControl('', [Validators.required]),
        color: new FormControl('#f44336', [Validators.required]),
        time: new FormControl('', [Validators.required, Validators.min(1)]),
        type: new FormControl(-1, [Validators.required, notDefaultValidator('-1')]),
        observatii: new FormControl('', []),
    });

    constructor(
        private dialogRef: MatDialogRef<AddCererePriorityComponent>,
        private requestService: PrioritiesService,
        private notificationService: NotificationService,
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    ngOnInit() { }

    submitForm() {
        this.isLoading = true;


        const { name, slug, color, time, type, observatii } = this.form.value;
        const payload: AddPriorities = {
            name, slug, color, time, type, observatii
        };

        this.requestService
            .storeEntry(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
